import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const SettingsContext = createContext();

const DAY_KEYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
const DAY_LABELS = { mon: 'Monday', tue: 'Tuesday', wed: 'Wednesday', thu: 'Thursday', fri: 'Friday', sat: 'Saturday', sun: 'Sunday' };

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    axios.get('/api/settings/public').then(r => setSettings(r.data)).catch(() => {});
  }, []);

  const hours = DAY_KEYS.map(key => [DAY_LABELS[key], settings[`hours_${key}`] || '']);
  const todayKey = DAY_KEYS[(new Date().getDay() + 6) % 7];
  const todayLabel = DAY_LABELS[todayKey];
  const todayHours = settings[`hours_${todayKey}`] || '';

  return (
    <SettingsContext.Provider value={{ settings, hours, todayLabel, todayHours }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
